import { useEffect, useState } from "react";
import { useDolfinClient } from "@/components/DolfinProvider";
import type { components } from "@dolfin/api-admin";

type SupplierResponse = components["schemas"]["SupplierResponse"];

export function useSupplier(id: string | null | undefined) {
  const api = useDolfinClient();
  const [supplier, setSupplier] = useState<SupplierResponse | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) {
      setSupplier(null);
      return;
    }
    setLoading(true);
    api
      .GET("/v1/suppliers/{id}", { params: { path: { id } } })
      .then(({ data }) => setSupplier(data ?? null))
      .catch(() => setSupplier(null))
      .finally(() => setLoading(false));
  }, [id, api]);

  return { supplier, loading };
}
